/** Пустая функция для использования в дефолтных параметрах. Так же является заглушкой */
export const voidFunction = () => {};
